import React, {useRef, useEffect, useState} from 'react'
import PropTypes from 'prop-types'
import { ContentMain, ContentOutput, PdfFormContainer, ContentOutputWithForm } from './index.style'
import Container from '@components/Container'
import Grid from '@components/Grid'
import GridItem from '@components/GridItem'
import Spacer from '@components/Spacer'
import RichText from '@components/RichText'
import PdfForm from '@components/PdfForm'
import gsap from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
import { breakpoints } from '@styles/vars/breakpoints.style'

const Content = ({ data, slug }) => {

  const [showList, setShowList] = useState(false)
  const $list = useRef()
  const $listInner = useRef()
  const $sidebar = useRef()
  const maxMobileHeight = 630

  const toggleMobileList = () => {
    gsap.to($list.current, {
      height: showList ? maxMobileHeight : $listInner.current.scrollHeight,
      duration: 0.4,
      ease: 'inOut',
      onComplete: () => {
        setShowList(!showList)
        gsap.set($list.current, {
          clearProps: 'all',
        })
      },
    })
  }

  return (
    <ContentMain>
      <Spacer size={[20, 40]} />
      <Container>
        <ContentOutput className={slug}>
          <RichText content={data} article />
        </ContentOutput>
      </Container>
      <Spacer size={[20, 40]} />
    </ContentMain>
  )
}

Content.propTypes = {
  data: PropTypes.object,
  slug: PropTypes.string
}

export default Content
